/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AppRouteImport } from './routes/_app'
import { Route as LoginRouteImport } from './routes/login'
import { Route as SetPasswordRouteImport } from './routes/set-password'
import { Route as AppIndexRouteImport } from './routes/_app/index'
import { Route as AppAuthPolicyRouteImport } from './routes/_app/auth-policy'
import { Route as AppCalendarRouteImport } from './routes/_app/calendar'
import { Route as AppEmailRouteImport } from './routes/_app/email'
import { Route as AppOrdersRouteImport } from './routes/_app/orders'
import { Route as AppOrganizationsRouteImport } from './routes/_app/organizations'
import { Route as AppPlatformEmailRouteImport } from './routes/_app/platform-email'
import { Route as AppPlatformSsoRouteImport } from './routes/_app/platform-sso'
import { Route as AppProfileRouteImport } from './routes/_app/profile'
import { Route as AppSsoRouteImport } from './routes/_app/sso'
import { Route as AppUsersRouteImport } from './routes/_app/users'
import { Route as AppOrdersIndexRouteImport } from './routes/_app/orders.index'
import { Route as AppOrdersOrderIdRouteImport } from './routes/_app/orders.$orderId'

const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const SetPasswordRoute = SetPasswordRouteImport.update({
  id: '/set-password',
  path: '/set-password',
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRoute,
} as any)
const AppAuthPolicyRoute = AppAuthPolicyRouteImport.update({
  id: '/auth-policy',
  path: '/auth-policy',
  getParentRoute: () => AppRoute,
} as any)
const AppCalendarRoute = AppCalendarRouteImport.update({
  id: '/calendar',
  path: '/calendar',
  getParentRoute: () => AppRoute,
} as any)
const AppEmailRoute = AppEmailRouteImport.update({
  id: '/email',
  path: '/email',
  getParentRoute: () => AppRoute,
} as any)
const AppOrdersRoute = AppOrdersRouteImport.update({
  id: '/orders',
  path: '/orders',
  getParentRoute: () => AppRoute,
} as any)
const AppOrganizationsRoute = AppOrganizationsRouteImport.update({
  id: '/organizations',
  path: '/organizations',
  getParentRoute: () => AppRoute,
} as any)
const AppPlatformEmailRoute = AppPlatformEmailRouteImport.update({
  id: '/platform-email',
  path: '/platform-email',
  getParentRoute: () => AppRoute,
} as any)
const AppPlatformSsoRoute = AppPlatformSsoRouteImport.update({
  id: '/platform-sso',
  path: '/platform-sso',
  getParentRoute: () => AppRoute,
} as any)
const AppProfileRoute = AppProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => AppRoute,
} as any)
const AppSsoRoute = AppSsoRouteImport.update({
  id: '/sso',
  path: '/sso',
  getParentRoute: () => AppRoute,
} as any)
const AppUsersRoute = AppUsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => AppRoute,
} as any)
const AppOrdersIndexRoute = AppOrdersIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppOrdersRoute,
} as any)
const AppOrdersOrderIdRoute = AppOrdersOrderIdRouteImport.update({
  id: '/$orderId',
  path: '/$orderId',
  getParentRoute: () => AppOrdersRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof AppIndexRoute
  '/login': typeof LoginRoute
  '/set-password': typeof SetPasswordRoute
  '/auth-policy': typeof AppAuthPolicyRoute
  '/calendar': typeof AppCalendarRoute
  '/email': typeof AppEmailRoute
  '/orders': typeof AppOrdersRouteWithChildren
  '/organizations': typeof AppOrganizationsRoute
  '/platform-email': typeof AppPlatformEmailRoute
  '/platform-sso': typeof AppPlatformSsoRoute
  '/profile': typeof AppProfileRoute
  '/sso': typeof AppSsoRoute
  '/users': typeof AppUsersRoute
  '/orders/$orderId': typeof AppOrdersOrderIdRoute
  '/orders/': typeof AppOrdersIndexRoute
}
export interface FileRoutesByTo {
  '/login': typeof LoginRoute
  '/set-password': typeof SetPasswordRoute
  '/auth-policy': typeof AppAuthPolicyRoute
  '/calendar': typeof AppCalendarRoute
  '/email': typeof AppEmailRoute
  '/organizations': typeof AppOrganizationsRoute
  '/platform-email': typeof AppPlatformEmailRoute
  '/platform-sso': typeof AppPlatformSsoRoute
  '/profile': typeof AppProfileRoute
  '/sso': typeof AppSsoRoute
  '/users': typeof AppUsersRoute
  '/': typeof AppIndexRoute
  '/orders/$orderId': typeof AppOrdersOrderIdRoute
  '/orders': typeof AppOrdersIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_app': typeof AppRouteWithChildren
  '/login': typeof LoginRoute
  '/set-password': typeof SetPasswordRoute
  '/_app/auth-policy': typeof AppAuthPolicyRoute
  '/_app/calendar': typeof AppCalendarRoute
  '/_app/email': typeof AppEmailRoute
  '/_app/orders': typeof AppOrdersRouteWithChildren
  '/_app/organizations': typeof AppOrganizationsRoute
  '/_app/platform-email': typeof AppPlatformEmailRoute
  '/_app/platform-sso': typeof AppPlatformSsoRoute
  '/_app/profile': typeof AppProfileRoute
  '/_app/sso': typeof AppSsoRoute
  '/_app/users': typeof AppUsersRoute
  '/_app/': typeof AppIndexRoute
  '/_app/orders/$orderId': typeof AppOrdersOrderIdRoute
  '/_app/orders/': typeof AppOrdersIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/set-password'
    | '/auth-policy'
    | '/calendar'
    | '/email'
    | '/orders'
    | '/organizations'
    | '/platform-email'
    | '/platform-sso'
    | '/profile'
    | '/sso'
    | '/users'
    | '/orders/$orderId'
    | '/orders/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/login'
    | '/set-password'
    | '/auth-policy'
    | '/calendar'
    | '/email'
    | '/organizations'
    | '/platform-email'
    | '/platform-sso'
    | '/profile'
    | '/sso'
    | '/users'
    | '/'
    | '/orders/$orderId'
    | '/orders'
  id:
    | '__root__'
    | '/_app'
    | '/login'
    | '/set-password'
    | '/_app/auth-policy'
    | '/_app/calendar'
    | '/_app/email'
    | '/_app/orders'
    | '/_app/organizations'
    | '/_app/platform-email'
    | '/_app/platform-sso'
    | '/_app/profile'
    | '/_app/sso'
    | '/_app/users'
    | '/_app/'
    | '/_app/orders/$orderId'
    | '/_app/orders/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AppRoute: typeof AppRouteWithChildren
  LoginRoute: typeof LoginRoute
  SetPasswordRoute: typeof SetPasswordRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/set-password': {
      id: '/set-password'
      path: '/set-password'
      fullPath: '/set-password'
      preLoaderRoute: typeof SetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/': {
      id: '/_app/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/auth-policy': {
      id: '/_app/auth-policy'
      path: '/auth-policy'
      fullPath: '/auth-policy'
      preLoaderRoute: typeof AppAuthPolicyRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/calendar': {
      id: '/_app/calendar'
      path: '/calendar'
      fullPath: '/calendar'
      preLoaderRoute: typeof AppCalendarRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/email': {
      id: '/_app/email'
      path: '/email'
      fullPath: '/email'
      preLoaderRoute: typeof AppEmailRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/orders': {
      id: '/_app/orders'
      path: '/orders'
      fullPath: '/orders'
      preLoaderRoute: typeof AppOrdersRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/organizations': {
      id: '/_app/organizations'
      path: '/organizations'
      fullPath: '/organizations'
      preLoaderRoute: typeof AppOrganizationsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/platform-email': {
      id: '/_app/platform-email'
      path: '/platform-email'
      fullPath: '/platform-email'
      preLoaderRoute: typeof AppPlatformEmailRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/platform-sso': {
      id: '/_app/platform-sso'
      path: '/platform-sso'
      fullPath: '/platform-sso'
      preLoaderRoute: typeof AppPlatformSsoRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/profile': {
      id: '/_app/profile'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof AppProfileRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/sso': {
      id: '/_app/sso'
      path: '/sso'
      fullPath: '/sso'
      preLoaderRoute: typeof AppSsoRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/users': {
      id: '/_app/users'
      path: '/users'
      fullPath: '/users'
      preLoaderRoute: typeof AppUsersRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/orders/': {
      id: '/_app/orders/'
      path: '/'
      fullPath: '/orders/'
      preLoaderRoute: typeof AppOrdersIndexRouteImport
      parentRoute: typeof AppOrdersRoute
    }
    '/_app/orders/$orderId': {
      id: '/_app/orders/$orderId'
      path: '/$orderId'
      fullPath: '/orders/$orderId'
      preLoaderRoute: typeof AppOrdersOrderIdRouteImport
      parentRoute: typeof AppOrdersRoute
    }
  }
}

interface AppOrdersRouteChildren {
  AppOrdersOrderIdRoute: typeof AppOrdersOrderIdRoute
  AppOrdersIndexRoute: typeof AppOrdersIndexRoute
}

const AppOrdersRouteChildren: AppOrdersRouteChildren = {
  AppOrdersOrderIdRoute: AppOrdersOrderIdRoute,
  AppOrdersIndexRoute: AppOrdersIndexRoute,
}

const AppOrdersRouteWithChildren = AppOrdersRoute._addFileChildren(
  AppOrdersRouteChildren,
)

interface AppRouteChildren {
  AppAuthPolicyRoute: typeof AppAuthPolicyRoute
  AppCalendarRoute: typeof AppCalendarRoute
  AppEmailRoute: typeof AppEmailRoute
  AppOrdersRoute: typeof AppOrdersRouteWithChildren
  AppOrganizationsRoute: typeof AppOrganizationsRoute
  AppPlatformEmailRoute: typeof AppPlatformEmailRoute
  AppPlatformSsoRoute: typeof AppPlatformSsoRoute
  AppProfileRoute: typeof AppProfileRoute
  AppSsoRoute: typeof AppSsoRoute
  AppUsersRoute: typeof AppUsersRoute
  AppIndexRoute: typeof AppIndexRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppAuthPolicyRoute: AppAuthPolicyRoute,
  AppCalendarRoute: AppCalendarRoute,
  AppEmailRoute: AppEmailRoute,
  AppOrdersRoute: AppOrdersRouteWithChildren,
  AppOrganizationsRoute: AppOrganizationsRoute,
  AppPlatformEmailRoute: AppPlatformEmailRoute,
  AppPlatformSsoRoute: AppPlatformSsoRoute,
  AppProfileRoute: AppProfileRoute,
  AppSsoRoute: AppSsoRoute,
  AppUsersRoute: AppUsersRoute,
  AppIndexRoute: AppIndexRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AppRoute: AppRouteWithChildren,
  LoginRoute: LoginRoute,
  SetPasswordRoute: SetPasswordRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
